<template>
  <div :class="getClassName('alert')" v-if="visible">
    <div :class="getClassName('alert__overlay')" @click="hide"></div>
    <div :class="getClassName('alert__wrapper')">
      <div :class="['alert__content--' + varient, getClassName('alert__content')]">
        <div :class="getClassName('alert__message')" v-for="(message, index) in messages" :key="index">
          {{ message }}
        </div>
        <button :class="getClassName('alert__close')" type="button" @click="hide">
          <span :class="getClassName('alert__cross')" />
          閉じる
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import getClassName from '../_mixins/getClassName';

export default {
  mixins: [getClassName],
  props: {
    visible: {
      type: Boolean,
      required: true,
      default: false,
    },
    varient: {
      type: String,
      required: true,
      default: 'info',
    },
    messages: {
      type: Array,
      required: true,
      default: () => [],
    },
    media: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  methods: {
    hide() {
      this.$emit('hide');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../_sass/variables';
@import '../_sass/modal';

.alert {
  &__overlay {
    @extend %overlay;
  }
  &__wrapper {
    @extend %wrapper;
    width: 390px;
    &--sp {
      width: 87.5%;
    }
  }
  &__content {
    background: #f9f9f9;
    min-height: 192px;
    max-height: 80vh;
    padding: 31px;
    box-sizing: border-box;
    font-family: 'NotoSansJP-Medium', sans-serif;
    display: flex;
    flex-flow: column nowrap;
    justify-content: center;
    align-items: center;
    overflow: auto;
    &::before {
      content: '';
      width: 33px;
      height: 33px;
      display: block;
    }
    &--error {
      background: $color__active;
      color: #fff;
      &::before {
        background: url(../images/alert.svg) no-repeat center center;
        background-size: contain;
      }
    }
    &--sp {
      min-height: 140px;
      padding: 30px;
      &::before {
        width: 24px;
        height: 24px;
      }
    }
  }

  &__message {
    font-size: 1.5rem;
    text-align: center;
    &:first-of-type {
      margin-top: 25px;
    }
    &--sp {
      margin-top: 15px;
      font-size: 1.2rem;
      text-align: center;
    }
  }

  &__close {
    width: 66px;
    margin-top: 25px;
    outline: none;
    font-family: 'NotoSansJP-Regular', sans-serif;
    display: flex;
    justify-content: center;
    align-items: center;
    &--sp {
      margin-top: 20px;
    }
  }

  &__cross {
    width: 26px;
    height: 26px;
    transform: rotate(45deg);
    position: relative;
    &::before,
    &::after {
      content: '';
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
    &::before {
      width: 100%;
      height: 0;
      border-top: solid 1px currentcolor;
    }
    &::after {
      width: 0;
      height: 100%;
      border-right: solid 1px currentcolor;
    }
    &--sp {
      width: 19px;
      height: 19px;
    }
  }
}
</style>
